
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4681_13977)"}},[_c('path',{attrs:{"d":"M7 8a4 4 0 100-8 4 4 0 000 8zM5.572 9.5A5.57 5.57 0 000 15.072c0 .512.416.928.928.928h12.144a.928.928 0 00.928-.928A5.57 5.57 0 008.428 9.5H5.572z","fill":"#910000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4681_13977"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v16H0z"}})])])])
          )
        }
      }
    